import { render, staticRenderFns } from "./FeaturedHotels.vue?vue&type=template&id=531c2ab8&scoped=true"
import script from "./FeaturedHotels.vue?vue&type=script&lang=js"
export * from "./FeaturedHotels.vue?vue&type=script&lang=js"
import style0 from "./FeaturedHotels.vue?vue&type=style&index=0&id=531c2ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c2ab8",
  null
  
)

export default component.exports